import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    landing_title: "Begin Your Shared Journey",
    landing_subtitle: "A warm space to meet someone who understands your roots, your faith, and the life you dream of building",
    get_started: "Get Started",
    login: "Login",
    email_placeholder: "Enter your email address",
    send_otp: "Send Verification Code",
    enter_otp: "Enter the code sent to your email",
    verify: "Verify",
    passkey: "Site Passkey",
    passkey_placeholder: "Enter site passkey",
    select_gender: "Select Your Gender",
    male: "Male",
    female: "Female",
    next: "Next",
    name: "Full Name",
    age: "Age",
    domicile: "Domicile / City",
    education: "Education",
    occupation: "Occupation",
    phone_number: "Phone Number",
    whatsapp: "WhatsApp Number",
    instagram: "Instagram Username",
    bio: "About",
    upload_photo: "Upload Photo",
    primary_photo: "Primary Photo",
    optional_photo: "Optional Photo",
    browse: "Browse",
    profile: "My Profile",
    claim_profile: "Claim Profile",
    this_is_me: "This Is Me",
    enter_your_name: "Enter your name",
    admin_login: "Admin Login",
    email: "Email",
    password: "Password",
    dashboard: "Dashboard",
    members: "Member Profiles",
    create_member: "Create Member Profile",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    total_profiles: "Total Profiles",
    total_accounts: "Total Accounts",
    claimed_profiles: "Claimed Profiles",
    logout: "Logout",
    back: "Back",
    features: "Features",
    categories: "Categories",
    open_whatsapp: "Open WhatsApp",
    open_instagram: "Open Instagram",
    filter_by_domicile: "Filter by domicile",
    filter_by_category: "Filter by category",
    sort_by: "Sort by",
    all: "All",
    no_profiles: "No profiles found",
    manage_passkey: "Manage Passkey",
    current_passkey: "Current Passkey",
    update_passkey: "Update Passkey",
    view_profile: "View Profile",
    accounts: "Member Accounts",
    search: "Search...",
    dark_mode: "Dark",
    light_mode: "Light",
    member_directory: "Member Catalog",
    already_claimed: "Already Claimed",
    not_claimed: "Not Claimed Yet",
    resend_otp: "Resend Code",
    photo: "Photo",
    actions: "Actions",
    gender: "Gender",
    category: "Category",
  },
  id: {
    landing_title: "Cerita Kita Dimulai di Sini",
    landing_subtitle: "Platform perjodohan utama Indonesia yang menghubungkan hati lintas budaya dan keyakinan",
    get_started: "Mulai Sekarang",
    login: "Masuk",
    email_placeholder: "Masukkan alamat email",
    send_otp: "Kirim Kode Verifikasi",
    enter_otp: "Masukkan kode yang dikirim ke email",
    verify: "Verifikasi",
    passkey: "Kunci Situs",
    passkey_placeholder: "Masukkan kunci situs",
    select_gender: "Pilih Jenis Kelamin",
    male: "Pria",
    female: "Wanita",
    next: "Selanjutnya",
    name: "Nama Lengkap",
    age: "Usia",
    domicile: "Domisili / Kota",
    education: "Pendidikan",
    occupation: "Pekerjaan",
    phone_number: "Nomor Telepon",
    whatsapp: "Nomor WhatsApp",
    instagram: "Username Instagram",
    bio: "Tentang",
    upload_photo: "Unggah Foto",
    primary_photo: "Foto Utama",
    optional_photo: "Foto Opsional",
    browse: "Jelajahi",
    profile: "Profil Saya",
    claim_profile: "Klaim Profil",
    this_is_me: "Ini Saya",
    enter_your_name: "Masukkan namamu",
    admin_login: "Masuk Admin",
    email: "Email",
    password: "Kata Sandi",
    dashboard: "Dasbor",
    members: "Profil Anggota",
    create_member: "Buat Profil Anggota",
    edit: "Ubah",
    delete: "Hapus",
    save: "Simpan",
    cancel: "Batal",
    total_profiles: "Total Profil",
    total_accounts: "Total Akun",
    claimed_profiles: "Profil Diklaim",
    logout: "Keluar",
    back: "Kembali",
    features: "Fitur",
    categories: "Kategori",
    open_whatsapp: "Buka WhatsApp",
    open_instagram: "Buka Instagram",
    filter_by_domicile: "Filter domisili",
    filter_by_category: "Filter kategori",
    sort_by: "Urutkan",
    all: "Semua",
    no_profiles: "Tidak ada profil ditemukan",
    manage_passkey: "Kelola Kunci Situs",
    current_passkey: "Kunci Saat Ini",
    update_passkey: "Perbarui Kunci",
    view_profile: "Lihat Profil",
    accounts: "Akun Anggota",
    search: "Cari...",
    dark_mode: "Gelap",
    light_mode: "Terang",
    member_directory: "Katalog Anggota",
    already_claimed: "Sudah Diklaim",
    not_claimed: "Belum Diklaim",
    resend_otp: "Kirim Ulang",
    photo: "Foto",
    actions: "Aksi",
    gender: "Gender",
    category: "Kategori",
  }
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem('mg_lang') || 'id');

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;

  const toggleLang = () => {
    const newLang = lang === 'en' ? 'id' : 'en';
    setLang(newLang);
    localStorage.setItem('mg_lang', newLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
